import { Option } from './option.interface';

export const defaultOptionValue = '_DEFAULT';
export const allOptionValue = '_ALL';

export const createOption = (option: String|number, title?: String|number): Option => {
  return {
    option,
    title: title ? title : option,
  };
};

export const defaultOption = createOption(defaultOptionValue, '-');
